import {lazy} from 'react';
import {getCorrespondLabel} from '@/utils/global';

const PlayerRoutes = [
    {
        label: '播放器',
        key: 'player',
        show: false,
        path: '/player',
        element: lazy(() => import('@/components/Layout/PlayerLayout')),
        needJudgeRealName: true,
        realNameType: 'player',
        children: [
            {
                label: getCorrespondLabel('104') + '播放器',
                key: 'project-player',
                show: false,
                path: 'project',
                element: lazy(() => import('@/page/Player/ProjectPlayer/indexPlayer'))
            },
            {
                label: getCorrespondLabel('107') + '播放器',
                key: 'audio-book-player',
                show: false,
                path: 'audio-book',
                element: lazy(() => import('@/page/Player/AudioBookPlayer'))
            },
            {
                label: getCorrespondLabel('107') + '播放器',
                key: 'parent-school-player',
                show: false,
                path: 'parent-school',
                element: lazy(() => import('@/page/Player/ParentSchoolPlayer/indexPlayer'))
            },
            {
                label: getCorrespondLabel('101') + '播放器',
                key: 'open-course-player',
                show: false,
                path: 'open-course',
                element: lazy(() => import('@/page/Player/OpenCoursePlayer/indexPlayer'))
            },
            {
                label: getCorrespondLabel('103') + '播放器',
                key: 'online-seminar-player',
                show: false,
                path: 'online-seminar',
                element: lazy(() => import('@/page/Player/OnlineSeminar'))
            }
        ]
    }
];

export default PlayerRoutes;
